import React from 'react'

const GetInvolved = () => {
  return (
    <>
      <div style={{ fontSize: "40px", marginTop: "200px" }}>Get Involved</div>
      <div style={{ fontSize: "40px", marginTop: "10px" }}>Coming Soon...</div>
    </>
  )
}

export default GetInvolved